import apiClient from './client'

export const adminApi = {
  getStats: () =>
    apiClient.get('/stats').then((r) => r.data),

  getUsers: (params?: Record<string, unknown>) =>
    apiClient.get('/admin/users', { params }).then((r) => r.data.data ?? r.data),

  createUser: (data: Record<string, unknown>) =>
    apiClient.post('/admin/users', data).then((r) => r.data),

  updateUser: (id: number, data: Record<string, unknown>) =>
    apiClient.put(`/admin/users/${id}`, data).then((r) => r.data),

  deleteUser: (id: number) =>
    apiClient.delete(`/admin/users/${id}`).then((r) => r.data),

  getApplications: (params?: Record<string, unknown>) =>
    apiClient.get('/admin/applications', { params }).then((r) => r.data.data ?? r.data),

  getApplication: (id: number) =>
    apiClient.get(`/admin/applications/${id}`).then((r) => r.data),

  approveApplication: (id: number, data: Record<string, unknown>) =>
    apiClient.put(`/admin/applications/${id}/approve`, data).then((r) => r.data),

  declineApplication: (id: number, data: Record<string, unknown>) =>
    apiClient.put(`/admin/applications/${id}/decline`, data).then((r) => r.data),

  getSessions: (params?: Record<string, unknown>) =>
    apiClient.get('/admin/sessions', { params }).then((r) => r.data.data ?? r.data),

  getRevenueReport: (params?: Record<string, unknown>) =>
    apiClient.get('/admin/reports/revenue', { params }).then((r) => r.data),

  getInterviewerReport: () =>
    apiClient.get('/admin/reports/interviewers').then((r) => r.data),

  getAuditLog: (params?: Record<string, unknown>) =>
    apiClient.get('/admin/security/audit-log', { params }).then((r) => r.data.data ?? r.data),

  getSettings: () =>
    apiClient.get('/admin/settings').then((r) => r.data),

  updateSettings: (settings: Record<string, unknown>[]) =>
    apiClient.put('/admin/settings', settings).then((r) => r.data),

  getQuestions: (params?: Record<string, unknown>) =>
    apiClient.get('/questions', { params }).then((r) => r.data.data ?? r.data),

  createQuestion: (data: Record<string, unknown>) =>
    apiClient.post('/questions', data).then((r) => r.data),

  updateQuestion: (id: number, data: Record<string, unknown>) =>
    apiClient.put(`/questions/${id}`, data).then((r) => r.data),

  deleteQuestion: (id: number) =>
    apiClient.delete(`/questions/${id}`).then((r) => r.data),

  getEvaluations: (params?: Record<string, unknown>) =>
    apiClient.get('/evaluations', { params }).then((r) => r.data.data ?? r.data),
}
